import { Button } from '@mantine/core';
import { IconBook } from '@tabler/icons-react';

/**
 * «Правила игры» — PDF в новой вкладке, во встроенном просмотрщике браузера.
 *
 * Какой документ открыть, решает сервер по записи игры и доступу к ней: у демо
 * — инструкция демо, у полной игры — путеводитель ведущего, с материалами
 * полной игры. Поэтому кнопка ставится только там, где игра открыта: на
 * закрытой полной игре путеводителя нет, и сервер его не отдаст.
 */
export function rulesDocumentUrl(gameSlug: string): string {
  return `/api/games/${encodeURIComponent(gameSlug)}/rules`;
}

export function GameRulesButton({
  gameSlug,
  label = 'Правила игры',
  variant = 'subtle',
}: {
  gameSlug: string;
  label?: string;
  variant?: 'subtle' | 'light';
}) {
  return (
    <Button
      component="a"
      href={rulesDocumentUrl(gameSlug)}
      target="_blank"
      rel="noopener"
      variant={variant}
      leftSection={<IconBook size={16} />}
      data-testid="game-rules"
    >
      {label}
    </Button>
  );
}
